import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white shadow-sm pl-5 pt-5 pr-5 pb-5"
}
const _hoisted_2 = { class: "mt-5 text-raleway-16 text-center" }
const _hoisted_3 = { class: "mt-5 text-motserrat-12-light text-center" }
const _hoisted_4 = { class: "d-flex" }

import LoadingComponent from "../loading/loadingComponent.vue";
import { toRefs, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalComponent',
  props: {
    title: {},
    button_1: {},
    button_2: {},
    callback1: { type: Function },
    callback2: { type: Function },
    callback3: { type: Function },
    smallText: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);
const titleArray = ref(data.title.value.split(" "));
const numberInString = ref((data.title.value?.match(/(\d+)/) || "")[0]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (typeof _ctx.callback3 === 'function' ? _ctx.callback3 : () => {})),
    class: "w-100 bg-modal d-flex j-content-center a-i-center direction-column"
  }, [
    (_ctx.isLoading !== true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc(titleArray.value[0]) +
          " " +
          (numberInString.value || "") +
          " " +
          _ctx.$tc(
            titleArray.value
              .filter((str, i) => i !== 0 && str !== numberInString.value?.toString())
              .join(" ")
          )), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(data).smallText?.value), 1),
          _createElementVNode("div", _hoisted_4, [
            (_unref(data).button_1?.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn btn-default m-auto mt-5 mb-5 btn-modal",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (typeof _ctx.callback1 === 'function' && _ctx.callback1()), ["stop"]))
                }, _toDisplayString(_unref(data).button_1?.value), 1))
              : _createCommentVNode("", true),
            (_unref(data).button_2?.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn btn-default m-auto mt-5 mb-5 btn-modal",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (typeof _ctx.callback2 === 'function' && _ctx.callback2()), ["stop"]))
                }, _toDisplayString(_unref(data).button_2?.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock(LoadingComponent, { key: 1 }))
  ]))
}
}

})